import { Modifier } from "@/modules/ooc/index";

export default class ModifierListing {
  name: string = "";
  original_name: string = "";
  id: string = "";
  external_id: string = "";
  local_name: string = "";
  original_local_name: string = "";
  quantifiable: boolean = false;
  type: string = "SINGLE";
  max_select: number = 0;
  min_select: number = 0;
  modifiers: Array<any> = [];
  image_url: string = "";
  staged: boolean = true;

  constructor(data) {
    if (data) {
      this.id = data.id || "";
      this.name = data.name || "";
      this.original_name = data.name || "";
      this.quantifiable = data.quantifiable || false;
      this.local_name = data.local_name || "";
      this.original_local_name = data.local_name || "";
      this.type = data.type || "SINGLE";
      this.max_select = data.max_select || 0;
      this.min_select = data.min_select || 0;
      this.modifiers = data.modifiers.map((modifier) => {
        return new Modifier(modifier);
      });
      this.staged = true;
    }
  }
}
